import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

const StatusDepositLoading: React.FunctionComponent = function () {
  return (
    <PleaseWaitOverlay
      icon="alarm"
      title="Your deposit form is loading"
      labelLine1="Please be patient, this shouldn't take long"
      labelLine2="During regular working hours we'll have an update every 10-15 minutes"
      labelLine3="You do not need to refresh unless asked to do so"
      isLoading
    />
  );
};

export default StatusDepositLoading;
